import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { useQuery } from 'react-apollo';
import { GET_SCAN_DATA } from '../queries';

const SelectSiteScan = ({
  selectedscanName,
  onscanNameSelect,
  hosId,
  placeholder,
  isHavingProcedure
}) => {
  const { loading, data } = useQuery(GET_SCAN_DATA, {
    variables: { input: { siteCode: hosId, isHavingProcedure } },
    skip: !hosId
  });

  const getScanDetails = (data && data.getScanDetails) || [];

  let siteopts = getScanDetails.map(item => ({
    label: item.scanName,
    value: item
  }));
  const selectedOpt =
    siteopts.find(({ value }) => value === selectedscanName) || null;
  return (
    <Select
      isLoading={loading}
      loadingMessage={() => 'fetching data'}
      isDisabled={loading}
      placeholder={placeholder || (loading ? '' : 'Select Scan')}
      options={siteopts}
      value={selectedOpt}
      onChange={e => {
        if (e && e.value) {
          onscanNameSelect(e.value);
        }
      }}
    />
  );
};

SelectSiteScan.propTypes = {
  selectedscanName: PropTypes.string,
  onscanNameSelect: PropTypes.func,
  hosId: PropTypes.string,
  placeholder: PropTypes.string,
  isHavingProcedure: PropTypes.bool
};

SelectSiteScan.defaultProps = {
  isHavingProcedure: false
};

export default SelectSiteScan;
